import { css } from '@/styled-system/css';

export const totalMonthlyPriceBadgeStyles = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 'bold',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  userSelect: 'none',
  textDecorationLine: 'underline',
  textDecorationThickness: '5%',

  md: {
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: '700',
  },

  '&[data-icon-variant="default"]': {
    color: 'hpxTeal500',
  },

  '&[data-icon-variant="white"]': {
    color: '#FFFFFF',
  },

  '&[data-variant="feesApply"]': {
    cursor: 'default',
    textDecorationLine: 'none',
    color: 'hpxGrey600',
    fontWeight: 'normal',

    md: {
      fontSize: '14px',
      fontWeight: 'normal',
    },
  },

  '&[data-variant="feesApply"][data-icon-variant="white"]': {
    color: '#FFFFFF',
  },

  '&[data-size="sm"]': {
    fontSize: '14px !important',
    md: {
      fontSize: '14px !important',
    },
  },

  '&[data-tooltip-disabled="true"]': {
    cursor: 'default',
    textDecorationLine: 'none',
  },
});

export const badgeIconStyles = css({
  width: '16px',
  height: '16px',
  flexShrink: 0,
});

export const tooltipWrapperStyles = css({
  display: 'inline-block',
});

export const totalMonthlyPriceNoticeStyles = css({
  fontSize: '14px',
  lineHeight: '16px',
  color: 'hpxGrey500',
});

export const learnMoreLinkStyles = css({
  textDecorationLine: 'underline',
  textDecorationThickness: '5%',
});
